<template>
    <div class="container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ name: 'Organisation' }"
                >Dashboard</el-breadcrumb-item
            >
            <el-breadcrumb-item>Settings</el-breadcrumb-item>
        </el-breadcrumb>

        <h1 class="container__title h1">Settings</h1>

        <div class="container__section container__section--space-small">
            <el-form ref="form" :model="formData" :rules="validationRules">
                <el-form-item
                    label="Linktree Name"
                    class="space-bottom space-bottom--medium"
                    prop="name"
                >
                    <el-input v-model="formData.name" @input="touchForm">
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="Linktree Vanity URL"
                    class="space-bottom space-bottom--medium"
                    prop="slug"
                >
                    <el-input v-model="formData.slug" @input="touchForm">
                        <template slot="prepend">clickthe.bio/</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="activeTree.type === 'link'"
                    label="Title Linklist"
                    class="space-bottom space-bottom--medium"
                    prop="title_linklist"
                >
                    <el-input
                        v-model="formData.title_linklist"
                        @input="touchForm"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="activeTree.type === 'link'"
                    label="Title Sociallinks"
                    class="space-bottom space-bottom--medium"
                    prop="title_sociallinks"
                >
                    <el-input
                        v-model="formData.title_sociallinks"
                        @input="touchForm"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="activeTree.type === 'gallery'"
                    label="Newsletter Button Link"
                    class="space-bottom space-bottom--medium"
                    prop="newsletter_link"
                >
                    <el-input
                        v-model="formData.newsletter_link"
                        @input="touchForm"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="activeTree.type === 'gallery'"
                    label="Newsletter Button Label"
                    class="space-bottom space-bottom--medium"
                    prop="newsletter_button_label"
                >
                    <el-input
                        v-model="formData.newsletter_button_label"
                        @input="touchForm"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="activeTree.type === 'gallery'"
                    label="Newsletter Info Text"
                    class="space-bottom space-bottom--medium"
                    prop="newsletter_info_text"
                >
                    <el-input
                        v-model="formData.newsletter_info_text"
                        @input="touchForm"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="Inline Imprint"
                    class="space-bottom space-bottom--small"
                    prop="imprint"
                >
                    <ckeditor
                        v-model="formData.imprint"
                        :config="config"
                    ></ckeditor>
                </el-form-item>

                <el-form-item class="space-bottom">
                    <Button
                        size="big"
                        @click="submitForm"
                        :showLoader="isLoading"
                        >Save</Button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="container__section container__section--space-small">
            <h3 class="container__section__title h3">Delete tree</h3>
            <Button size="big" type="red" @click="deleteLinktree"
                >Delete</Button
            >
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as api from '@/api';
import Button from '@/components/Button.vue';

export default {
    components: {
        Button,
    },
    data() {
        return {
            config: {
                toolbar: [['Source', 'Bold', 'BulletedList', 'Link', 'Unlink']],
            },
            formTouched: false,
            isLoading: false,
            formData: {
                slug: '',
                name: '',
                imprint: '',
                title_sociallinks: '',
                title_linklist: '',
                newsletter_button_label: '',
                newsletter_info_text: '',
                newsletter_link: '',
            },
            validationRules: {
                slug: [
                    {
                        required: true,
                        message: 'Please pick a slug',
                        trigger: 'blur',
                    },
                    {
                        min: 2,
                        max: 100,
                        message:
                            '2-100 characters, only lower case letters, numbers and dashes',
                        trigger: 'blur',
                        pattern: /^([a-z0-9-]){1,250}$/,
                    },
                ],
            },
        };
    },
    watch: {
        activeTree() {
            this.prepareData();
        },
    },
    computed: {
        ...mapGetters(['activeTree', 'user']),
    },
    mounted() {
        this.prepareData();
    },
    methods: {
        prepareData() {
            if (this.activeTree) {
                this.formData.slug = this.activeTree.slug;
                this.formData.name = this.$func.decodeHTMLEntities(
                    this.activeTree.name,
                );
                this.formData.imprint = this.activeTree.imprint;
                this.formData.title_sociallinks = this.$func.decodeHTMLEntities(
                    this.activeTree.title_sociallinks,
                );
                this.formData.title_linklist = this.$func.decodeHTMLEntities(
                    this.activeTree.title_linklist,
                );
                this.formData.newsletter_button_label = this.$func.decodeHTMLEntities(
                    this.activeTree.newsletter_button_label,
                );
                this.formData.newsletter_info_text = this.$func.decodeHTMLEntities(
                    this.activeTree.newsletter_info_text,
                );
                this.formData.newsletter_link = this.$func.decodeHTMLEntities(
                    this.activeTree.newsletter_link,
                );

                if (this.activeTree.links) {
                    this.socialLinks = this.activeTree.links.data.filter(l => {
                        return l.type.includes('social-');
                    });
                    this.socialLinks.sort((a, b) => {
                        return a.position - b.position;
                    });

                    this.footerLinks = this.activeTree.links.data.filter(l => {
                        return l.type === 'footer';
                    });
                    this.footerLinks.sort((a, b) => {
                        return a.position - b.position;
                    });
                }
            }
        },
        touchForm() {
            this.formTouched = true;
        },
        submitForm() {
            this.isLoading = true;
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.sendForm();
                    this.formTouched = false;
                } else {
                    this.isLoading = false;
                    return false;
                }
            });
        },
        async sendForm() {
            try {
                const response = await api.linktree.update(
                    this.activeTree.slug,
                    this.formData,
                );

                this.isLoading = false;

                if (
                    typeof response.response !== 'undefined' &&
                    response.response.status !== 200
                ) {
                    this.$message({
                        message: response.response.data.message,
                        type: 'error',
                    });
                } else {
                    this.$message({
                        message: 'Tree successfully saved!',
                        type: 'success',
                    });

                    this.$store.dispatch(
                        'loadOrganisation',
                        this.user.organisation.data.slug,
                    );
                    window.location =
                        '/admin/tree/' + this.formData.slug + '/settings';
                }
            } catch (error) {
                this.$message({
                    message: 'Something went wrong.',
                    type: 'error',
                });
                this.isLoading = false;
            }
        },
        updateOrder(links) {
            links.forEach((l, index) => {
                l.position = index;
                this.updateLink(l);
            });
            this.orderChanged = true;
        },
        async updateLink(link) {
            try {
                await api.link.update(link.slug, {
                    position: link.position,
                });
            } catch (error) {
                console.error(error);
            }
        },
        deleteLinktree() {
            this.$confirm(
                'Are you sure you want to delete this link tree?',
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning',
                },
            )
                .then(() => {
                    this.sendLinktreeDeletion();
                })
                .catch(() => {
                    console.log('cancelled');
                });
        },
        async sendLinktreeDeletion() {
            try {
                const response = await api.linktree.delete(
                    this.activeTree.slug,
                );
                if (response) {
                    this.$message({
                        message: 'Tree successfully deleted!',
                        type: 'success',
                    });
                    this.$store.dispatch(
                        'loadOrganisation',
                        this.user.organisation.data.slug,
                    );
                    this.$router.push({ name: 'Organisation' });
                }
            } catch (error) {
                console.error(error);
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (!this.formTouched || to.name == 'Login') {
            next();
        } else {
            this.$confirm(
                'Are you sure you want to leave without saving?',
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning',
                },
            )
                .then(() => {
                    next();
                })
                .catch(() => {
                    console.log('cancelled');
                });
        }
    },
};
</script>
